import { render, staticRenderFns } from "./ChatInfoOptions.vue?vue&type=template&id=7b47af56&scoped=true&"
import script from "./ChatInfoOptions.vue?vue&type=script&lang=js&"
export * from "./ChatInfoOptions.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfoOptions.vue?vue&type=style&index=0&id=7b47af56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b47af56",
  null
  
)

export default component.exports